/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Ui_Laps_Pace_RangeInputs */

const en_ui_laps_pace_range = /** @type {(inputs: Ui_Laps_Pace_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}–${i?.to} /km`)
};

const de_ui_laps_pace_range = /** @type {(inputs: Ui_Laps_Pace_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}–${i?.to} /km`)
};

/**
* | output |
* | --- |
* | "{from}–{to} /km" |
*
* @param {Ui_Laps_Pace_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_pace_range = /** @type {((inputs: Ui_Laps_Pace_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Pace_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_pace_range(inputs)
	return de_ui_laps_pace_range(inputs)
});